<template>
  <div class="my-class-schedule">
    <!-- <div class="curriculum-table-container">
      <div class="table-header-container">
        <div class="table-header-label lesson-label">
          <span>课节</span>
        </div>
        <div class="table-header-label time-label">时间</div>
        <div
          class="table-header-label week-label"
          v-for="(weekItem, weekIndex) in 7"
          :key="weekIndex"
        >
          星期{{
            weekIndex + 1 == 7 ? "天" : digitalToChineseWeek(weekIndex + 1)
          }}
        </div>
      </div>
      <div
        class="table-row-item-container"
        v-for="(lessonRowItem, lessonRowIndex) in myClassScheduleSelectData"
        :key="lessonRowIndex"
      >
        <div class="table-row-item lesson-label-item">
          <span>{{ lessonRowItem.lessonsName }}</span>
        </div>
        <div class="table-row-item time-item">
          <div
            class="time-gettime"
            v-if="lessonRowItem.startTime || lessonRowItem.endTime"
          >
            <span class="time-value">{{ lessonRowItem.startTime }}</span
            >至<span class="time-value">{{ lessonRowItem.endTime }}</span>
          </div>
        </div>
        <div class="lesson-list-container">
          <div
            class="table-row-item lesson-content-item"
            v-for="(lessonItem, lessonIndex) in lessonRowItem.lessons"
            :key="lessonIndex"
            :class="{
              checkedCourse: lessonItem.lessonsContent,
            }"
            :id="lessonIndex"
          >
            <div class="lesson-content-container">
              <div
                class="content-course-icon-container"
                v-if="lessonItem.lessonsContent"
              >
                <img
                  :src="
                    $courseList[lessonItem.lessonsContent]
                      ? $courseList[lessonItem.lessonsContent].courseIcon
                      : $courseList['其他'].courseIcon
                  "
                  class="content-course-icon"
                />
              </div>
              <div class="content-course-name-container">
                <span class="content-course-name">{{
                  lessonItem.lessonsContent
                }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div> -->


    <el-table :data="myClassScheduleSelectData" style="width: 100%" border>
      <el-table-column v-for="(header, index) in myClassScheduleSelectHeaders" :key="index" :label="header" align="center">
        <template slot-scope="scope">
          <!-- 将\r\n转换为<br>实现换行 -->
          <span v-html="formatCell(scope.row[index])"></span>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
//查看课节详情组件
import curriculumLessonDetail from "../curriculum-lesson-detail/curriculumLessonDetail";
export default {
  components: {
    curriculumLessonDetail,
  },
  data() {
    return {
      //已选择的课节详情
      checkedLessonDetail: null,
      //显示课节详情组件开关
      isCheckedLessonDetailDialogShow: false,
    };
  },
  props: {
    courseList: {
      type: Array,
    },
    myClassScheduleSelectData: {
      type: Array,
    },
    myClassScheduleSelectHeaders: {
      type: Array,
    }
  },
  methods: {
    formatCell(cellContent) {
      // 确保cellContent是一个字符串，并且处理其中的换行符
      if (typeof cellContent !== 'string') {
        return '';
      }
      return cellContent.replace(/\r\n/g, '<br>');
    },
    //数字转中文数字
    // digitalToChinese(number) {
    //   // 判断是否为数字
    //   if (isNaN(number)) return number;
    //   const digit_arr = [
    //     "",
    //     "一",
    //     "二",
    //     "三",
    //     "四",
    //     "五",
    //     "六",
    //     "七",
    //     "八",
    //     "九",
    //   ];
    //   let chineseNumber;
    //   if (number < 10) {
    //     chineseNumber = digit_arr[number];
    //   } else if (number >= 10 && number < 20) {
    //     let arr = number.toString().split("");
    //     chineseNumber = number == 10 ? "十" : `十${digit_arr[arr[1]]}`;
    //   } else {
    //     let arr = number.toString().split("");
    //     chineseNumber = `${digit_arr[arr[0]]}十${digit_arr[arr[1]]}`;
    //   }
    //   return `第${chineseNumber}节`;
    // },
    // //数字转中文数字
    // digitalToChineseWeek(number) {
    //   // 判断是否为数字
    //   if (isNaN(number)) return number;
    //   const digit_arr = [
    //     "",
    //     "一",
    //     "二",
    //     "三",
    //     "四",
    //     "五",
    //     "六",
    //     "七",
    //     "八",
    //     "九",
    //   ];
    //   let chineseNumber;
    //   if (number < 10) {
    //     chineseNumber = digit_arr[number];
    //   } else if (number >= 10 && number < 20) {
    //     let arr = number.toString().split("");
    //     chineseNumber = number == 10 ? "十" : `十${digit_arr[arr[1]]}`;
    //   } else {
    //     let arr = number.toString().split("");
    //     chineseNumber = `${digit_arr[arr[0]]}十${digit_arr[arr[1]]}`;
    //   }
    //   return chineseNumber;
    // },
    // showLessonDetail(lessonItem) {
    //   this.checkedLessonDetail = lessonItem;
    //   this.isCheckedLessonDetailDialogShow = true;
    // },
    // lessonDetailDialogClose() {
    //   this.isCheckedLessonDetailDialogShow = false;
    // },
  },
};
</script>

<style scoped lang="scss">
@import "./my-class-schedule.scss";
</style>